module.exports = __webpack_public_path__ + "static/media/white-ig.06eebc8c.svg";